<template>
  <!-- 运输规划  -->
  <div class="contents">
    <div class="queryBtns">
      <el-button
        v-if="hasPermiss('aaaaa')"
        class="chaXunBtns glo_bgcMainColor"
        @click="queryBtn_ok"
        >查询
      </el-button>
      <el-button class="chaXunBtns" @click="clerBtns">重置 </el-button>
      <el-button class="chaXunBtns" @click="myModel">表格设置 </el-button>
      <!-- tableSeting -->
    </div>
    <el-tabs
      class="glo_tabs"
      type="border-card"
      v-model="activeName"
      @tab-click="tabsClick"
    >
      <!-- =====提货===== -->
      <el-tab-pane label="提货" name="one">
        <div>
          <!-- 查询条件 -->
          <div ref="queryForm">
            <el-form
              :model="queryData"
              :class="isHaseMore ? 'glo_form hasMoreParam' : 'glo_form'"
              label-position="left"
            >
              <!-- 时间组件 -->
              <el-form-item class="queryItemsTimes">
                <multitime
                  :timeType="timeType"
                  :timeTypes="timeTypes"
                  :startTime="startTime_a"
                  :endTime="endTime_a"
                  @timestatus="timestatus"
                  @queryBtn_ok="queryBtn_time"
                >
                </multitime>
              </el-form-item>
              <el-form-item class="queryItemsAddress" label="提货地址:">
                <!-- 省 -->
                <el-select
                  style="width: 100px"
                  filterable
                  clearable
                  v-model="queryData.loadAddrProvinceName"
                  placeholder="请输入"
                  @change="changeProvinceName"
                >
                  <el-option
                    v-for="(item, index) in SuperiorRegionList"
                    :key="index"
                    :label="item.districtName"
                    :value="item.districtName"
                  ></el-option>
                </el-select>
                <!-- 市 -->
                <el-select
                  style="width: 100px"
                  filterable
                  clearable
                  v-model="queryData.loadAddrCityName"
                  placeholder="请输入"
                  @change="changeCityName"
                >
                  <el-option
                    v-for="(item, index) in SuperiorRegionList2"
                    :key="index"
                    :label="item.districtName"
                    :value="item.districtName"
                  ></el-option>
                </el-select>
                <!-- 区 -->
                <el-select
                  style="width: 100px"
                  filterable
                  clearable
                  v-model="queryData.loadAddrArea"
                  placeholder="请输入"
                  @change="getParentName($event, 3)"
                >
                  <el-option
                    v-for="(item, index) in SuperiorRegionList3"
                    :key="index"
                    :label="item.districtName"
                    :value="item.districtName"
                  ></el-option>
                </el-select>
                <!-- 详细地址 -->
                <el-input
                  placeholder="请输入详细地址"
                  clearable
                  v-model="queryData.loadAddrAddress"
                  @keyup.enter.native="queryBtn_ok"
                ></el-input>
              </el-form-item>
              <el-form-item class="queryItems" label="客户单号:">
                <el-input
                  clearable
                  placeholder="请输入"
                  v-model="queryData.customerOrderNumber"
                  @keyup.enter.native="queryBtn_ok"
                ></el-input>
              </el-form-item>
              <el-form-item class="queryItems" label="运单号:">
                <el-input
                  clearable
                  placeholder="请输入"
                  v-model="queryData.waybillNumber"
                  @keyup.enter.native="queryBtn_ok"
                ></el-input>
              </el-form-item>
              <el-form-item class="queryItems" label="客户名称:">
                <el-select
                  filterable
                  clearable
                  v-model="queryData.customerName"
                  placeholder="请输入"
                  remote
                  :remote-method="getCustomerList"
                  @focus="getCustomerList()"
                  @change="queryBtn_ok"
                >
                  <el-option
                    v-for="(item, index) in CustomerLists"
                    :key="index"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="queryItems" label="开单网点:">
                <el-select
                  filterable
                  clearable
                  v-model="queryData.businessDeptId"
                  placeholder="请输入"
                  @change="queryBtn_ok"
                >
                  <el-option
                    v-for="(item, index) in storageList"
                    :key="index"
                    :label="item.departmentName"
                    :value="item.deptId"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="queryItems" label="终端网点:">
                <el-select
                  filterable
                  clearable
                  v-model="queryData.endDeptId"
                  placeholder="请输入"
                  @change="queryBtn_ok"
                >
                  <el-option
                    v-for="(item, index) in storageList"
                    :key="index"
                    :label="item.departmentName"
                    :value="item.deptId"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="queryItems" label="运输方式:">
                <el-select
                  filterable
                  clearable
                  v-model="queryData.transportMethodConfDictId"
                  placeholder="请输入"
                  @focus="getConfDictValDownList('transport_method')"
                  @change="queryBtn_ok"
                >
                  <el-option
                    v-for="(item, index) in transportMethodList"
                    :key="index"
                    :label="item.key"
                    :value="item.confDictId"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="queryItems" label="提货方式:">
                <el-select
                  filterable
                  clearable
                  v-model="queryData.receiveMethodConfDictId"
                  placeholder="请输入"
                  @focus="getConfDictValDownList('receive_method')"
                  @change="queryBtn_ok"
                >
                  <el-option
                    v-for="(item, index) in receiveMethodList"
                    :key="index"
                    :label="item.key"
                    :value="item.confDictId"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="queryItems" label="送货方式:">
                <el-select
                  filterable
                  clearable
                  v-model="queryData.sendMethodConfDictId"
                  placeholder="请输入"
                  @focus="getConfDictValDownList('send_method')"
                  @change="queryBtn_ok"
                >
                  <el-option
                    v-for="(item, index) in sendMethodList"
                    :key="index"
                    :label="item.key"
                    :value="item.confDictId"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item class="queryItems" label="收货人:">
                <el-input
                  clearable
                  placeholder="请输入"
                  v-model="queryData.unloadContacts"
                  @keyup.enter.native="queryBtn_ok"
                ></el-input>
              </el-form-item>
              <el-form-item class="queryItems" label="收货单位:">
                <el-input
                  clearable
                  placeholder="请输入"
                  v-model="queryData.unloadCompany"
                  @keyup.enter.native="queryBtn_ok"
                ></el-input>
              </el-form-item>

              <el-form-item class="queryItems" label="净重:">
                <el-input
                  clearable
                  placeholder="请输入"
                  v-model="queryData.netWeight"
                  @keyup.enter.native="queryBtn_ok"
                ></el-input>
              </el-form-item>
              <el-form-item class="queryItems" label="计划承运商:">
                <!-- <el-input
                  clearable
                  placeholder="请输入"
                  v-model="queryData.outboundCarrierName"
                  @keyup.enter.native="queryBtn_ok"
                ></el-input> -->
                <el-select
                  clearable
                  filterable
                  v-model="queryData.outboundCarrierName"
                  placeholder="请选择"
                  @change="queryBtn_ok"
                >
                  <el-option
                    v-for="(item, index) in changeCarrierList"
                    :key="index"
                    :label="item.carrierName"
                    :value="item.carrierName"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div class="tb">
            <!-- 表格 -->
            <div class="glo_Table tbLeft">
              <el-table
                :height="tableHeigth"
                header-align="center"
                ref="mytable"
                @row-click="rowclick"
                :data="tableData"
                border
                stripe
                :highlight-current-row="true"
                show-summary
                :summary-method="getSummaries"
                @selection-change="handleSelectionChange"
              >
                <el-table-column
                  fixed="left"
                  align="center"
                  label="序号"
                  type="index"
                  width="60"
                >
                </el-table-column>
                <el-table-column
                  fixed="left"
                  align="center"
                  type="selection"
                  width="60"
                ></el-table-column>
                <template v-for="(item, index) in myTableHeard">
                  <!-- 某个字段需要单独操作  例如点击可以跳转 -->
                  <el-table-column
                    v-if="item.field == 'memberNickname' && item.isShow"
                    :key="index"
                    :label="item.name"
                    :prop="item.field"
                    align="center"
                    sortable
                    :show-overflow-tooltip="true"
                    :min-width="item.width"
                    :data-isTotal="item.isTotal"
                  >
                    <template slot-scope="scope">
                      <div
                        class="linkTabel"
                        @click.stop="goYdDetails(scope.row)"
                      >
                        {{ scope.row.memberNickname }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :key="index"
                    :label="item.name"
                    :prop="item.field"
                    align="center"
                    sortable
                    :show-overflow-tooltip="true"
                    :min-width="item.width"
                    :data-isTotal="item.isTotal"
                    v-else-if="item && item.isShow"
                  >
                  </el-table-column>
                </template>
                <!-- <el-table-column fixed="right" label="操作" min-width="280px">
                  <template slot-scope="scope">
                    <div class="tabRightBtns">
                      <el-button
                        class="rbtns"
                        @click.stop="WaybillEdit(scope.row)"
                        >修改</el-button
                      >
                      <el-button class="rbtns" @click.stop="chaiDan(scope.row)"
                        >拆单</el-button
                      >
                      <el-button
                        class="rbtns"
                        @click.stop="transportPlan(scope.row)"
                        >运输规划</el-button
                      >
                      <el-dropdown
                        class="rbtns"
                        @command="handleCommandBtns($event, scope.row)"
                      >
                        <el-button type="primary">
                          更多操作<i
                            class="el-icon-arrow-down el-icon--right"
                          ></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item command="a">详情</el-dropdown-item>
                          <el-dropdown-item command="b"
                            >外发录入</el-dropdown-item
                          >
                          <el-dropdown-item command="c"
                            >改运单号</el-dropdown-item
                          >
                          <el-dropdown-item command="d">删除</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                  </template>
                </el-table-column> -->
              </el-table>

              <!-- 分页 -->
              <paging
                ref="pags"
                :pageNum="pageStart1"
                :total="pageCount1"
                :size="pageTotal1"
                @handleSizeChange="handleSizeChange1"
                @handleCurrentChange="handleCurrentChange1"
              >
              </paging>
            </div>
            <!-- 右边生成任务 -->
            <div class="tbRight" :style="'height:' + tableHeigth">
              <el-form ref="form" :model="rightForm" label-width="100px">
                <el-form-item label="任务运输方式:">
                  <el-radio-group
                    v-model="rightForm.transportMethod"
                    @change="changeType"
                  >
                    <el-radio
                      v-for="(item, index) in transportMethodStatus"
                      :key="index"
                      :label="item.statusVal"
                      >{{ item.showName }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
                <el-form-item
                  label="外部承运商:"
                  v-if="
                    rightForm.transportMethod ===
                    'wai_bu_cheng_yun:transport_method'
                  "
                >
                  <el-select
                    clearable
                    filterable
                    v-model="rightForm.externalCarrierName"
                    placeholder="请选择"
                    @change="changecarrierName"
                  >
                    <el-option
                      v-for="(item, index) in changeCarrierList"
                      :key="index"
                      :label="item.carrierName"
                      :value="item.carrierName"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="运输计划:">
                  <el-radio-group
                    v-model="rightForm.transportPlan"
                    @change="changetransportPlan"
                  >
                    <el-radio
                      v-for="(item, index) in transportPlanList"
                      :key="index"
                      :label="item.statusVal"
                      >{{ item.showName }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
                <el-form-item
                  label="入仓仓库:"
                  v-if="rightForm.transportPlan === 'ru_cang:transport_plan'"
                >
                  <el-select
                    clearable
                    filterable
                    v-model="rightForm.storageId"
                    placeholder="请选择"
                    @change="changeRuCang"
                  >
                    <el-option
                      v-for="(item, index) in storageList"
                      :key="index"
                      :label="item.departmentName"
                      :value="item.deptId"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item
                  label="外发承运商:"
                  v-if="rightForm.transportPlan === 'wai_fa:transport_plan'"
                >
                  <el-select
                    clearable
                    filterable
                    v-model="rightForm.carrierName"
                    placeholder="请选择"
                    @change="changecarrierName2"
                  >
                    <el-option
                      v-for="(item, index) in changeCarrierList"
                      :key="index"
                      :label="item.carrierName"
                      :value="item.carrierName"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  label="外发网点:"
                  v-if="rightForm.transportPlan === 'wai_fa:transport_plan'"
                >
                  <el-select
                    clearable
                    filterable
                    v-model="rightForm.carrierDeptId"
                    placeholder="请选择"
                    @change="changeCarrierDep"
                  >
                    <el-option
                      v-for="(item, index) in CarrierDeptListList"
                      :key="index"
                      :label="item.deptName"
                      :value="item.carrierDeptId"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <div
                  v-if="rightForm.transportPlan === 'zhi_song:transport_plan'"
                >
                  <!-- 直送 -->
                  <el-form-item label="目的地址">
                    <el-input
                      placeholder="对应运单的收货地址"
                      type="text"
                      readonly
                    ></el-input>
                  </el-form-item>
                </div>
                <!-- 目的地 -->
                <div
                  v-if="rightForm.transportPlan !== 'zhi_song:transport_plan'"
                >
                  <el-form-item label="目的地址:">
                    <el-input
                      placeholder="自动获取仓库地址"
                      readonly
                      clearable
                      v-model="rightForm.addressAll"
                      type="textarea"
                    ></el-input>
                  </el-form-item>
                </div>
                <el-form-item label="备注:">
                  <el-input
                    placeholder="请输入"
                    clearable
                    v-model="rightForm.remarks"
                    type="textarea"
                  ></el-input>
                </el-form-item>
              </el-form>

              <div class="rbtns">
                <el-button
                  class="creatPlanBtns glo_bgcMainColor"
                  @click="submitBtns(1)"
                  >生成任务</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <!-- =====内部仓配送===== -->
      <el-tab-pane label="内部仓配送" name="two">
        <div>
          <!-- 查询条件 -->
          <div ref="queryForm2">
            <el-form
              :model="queryData2"
              :class="isHaseMore ? 'glo_form hasMoreParam' : 'glo_form'"
              label-position="left"
            >
              <!-- 时间组件 -->
              <el-form-item class="queryItemsTimes">
                <multitime
                  :timeType="timeType"
                  :timeTypes="timeTypes"
                  :startTime="startTime_a"
                  :endTime="endTime_a"
                  @timestatus="timestatus"
                  @queryBtn_ok="queryBtn_time"
                >
                </multitime>
              </el-form-item>
              <el-form-item class="queryItemsAddress" label="收货地址:">
                <!-- 省 -->
                <el-select
                  style="width: 100px"
                  filterable
                  clearable
                  v-model="queryData2.recipeAddrProvinceName"
                  placeholder="请输入"
                  @change="changeProvinceName2"
                >
                  <el-option
                    v-for="(item, index) in SuperiorRegionList"
                    :key="index"
                    :label="item.districtName"
                    :value="item.districtName"
                  ></el-option>
                </el-select>
                <!-- 市 -->
                <el-select
                  style="width: 100px"
                  filterable
                  clearable
                  v-model="queryData2.recipeAddrCityName"
                  placeholder="请输入"
                  @change="changeCityName2"
                >
                  <el-option
                    v-for="(item, index) in SuperiorRegionList2"
                    :key="index"
                    :label="item.districtName"
                    :value="item.districtName"
                  ></el-option>
                </el-select>
                <!-- 区 -->
                <el-select
                  style="width: 100px"
                  filterable
                  clearable
                  v-model="queryData2.recipeAddrAddress"
                  placeholder="请输入"
                  @change="getParentName($event, 3)"
                >
                  <el-option
                    v-for="(item, index) in SuperiorRegionList3"
                    :key="index"
                    :label="item.districtName"
                    :value="item.districtName"
                  ></el-option>
                </el-select>
                <!-- 详细地址 -->
                <el-input
                  placeholder="请输入详细地址"
                  clearable
                  v-model="queryData2.recipeAddrAddress"
                  @keyup.enter.native="queryBtn_ok"
                ></el-input>
              </el-form-item>

              <el-form-item class="queryItems" label="运单号:">
                <el-input
                  clearable
                  v-model="queryData2.waybillNumber"
                  placeholder="请输入"
                  @keyup.enter.native="queryBtn_ok"
                ></el-input>
              </el-form-item>
              <el-form-item class="queryItems" label="收货人:">
                <el-input
                  clearable
                  v-model="queryData2.recipeContacts"
                  placeholder="请输入"
                  @keyup.enter.native="queryBtn_ok"
                ></el-input>
              </el-form-item>
              <el-form-item class="queryItems" label="客户单号:">
                <el-input
                  clearable
                  v-model="queryData2.customerOrderNumber"
                  placeholder="请输入"
                  @keyup.enter.native="queryBtn_ok"
                ></el-input>
              </el-form-item>
              <el-form-item class="queryItems" label="客户名称:">
                <el-select
                  filterable
                  clearable
                  v-model="queryData2.customerName"
                  placeholder="请输入"
                  remote
                  :remote-method="getCustomerList"
                  @focus="getCustomerList()"
                  @change="queryBtn_ok"
                >
                  <el-option
                    v-for="(item, index) in CustomerLists"
                    :key="index"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="queryItems" label="开单网点:">
                <el-select
                  filterable
                  clearable
                  v-model="queryData2.businessDeptId"
                  placeholder="请输入"
                  @change="queryBtn_ok"
                >
                  <el-option
                    v-for="(item, index) in storageList"
                    :key="index"
                    :label="item.departmentName"
                    :value="item.deptId"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="queryItems" label="终端网点:">
                <el-select
                  filterable
                  clearable
                  v-model="queryData2.endDeptId"
                  placeholder="请输入"
                  @change="queryBtn_ok"
                >
                  <el-option
                    v-for="(item, index) in storageList"
                    :key="index"
                    :label="item.departmentName"
                    :value="item.deptId"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="queryItems" label="运输方式:">
                <el-select
                  filterable
                  clearable
                  v-model="queryData2.transportMethodConfDictId"
                  placeholder="请输入"
                  @focus="getConfDictValDownList('transport_method')"
                  @change="queryBtn_ok"
                >
                  <el-option
                    v-for="(item, index) in transportMethodList"
                    :key="index"
                    :label="item.key"
                    :value="item.confDictId"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="queryItems" label="提货方式:">
                <el-select
                  filterable
                  clearable
                  v-model="queryData2.receiveMethodConfDictId"
                  placeholder="请输入"
                  @focus="getConfDictValDownList('receive_method')"
                  @change="queryBtn_ok"
                >
                  <el-option
                    v-for="(item, index) in receiveMethodList"
                    :key="index"
                    :label="item.key"
                    :value="item.confDictId"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="queryItems" label="送货方式:">
                <el-select
                  filterable
                  clearable
                  v-model="queryData2.sendMethodConfDictId"
                  placeholder="请输入"
                  @focus="getConfDictValDownList('send_method')"
                  @change="queryBtn_ok"
                >
                  <el-option
                    v-for="(item, index) in sendMethodList"
                    :key="index"
                    :label="item.key"
                    :value="item.confDictId"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="queryItems" label="在途状态:">
                <el-select
                  filterable
                  clearable
                  v-model="queryData2.onwayStatus"
                  placeholder="请输入"
                  @change="queryBtn_ok"
                >
                  <el-option
                    v-for="(item, index) in OnwayStatusList"
                    :key="index"
                    :label="item.showName"
                    :value="item.statusVal"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="queryItems" label="当前站点:">
                <el-select
                  filterable
                  clearable
                  v-model="queryData2.currentDeptId"
                  placeholder="请输入"
                  @change="queryBtn_ok"
                >
                  <el-option
                    v-for="(item, index) in storageList"
                    :key="index"
                    :label="item.departmentName"
                    :value="item.deptId"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="queryItems" label="原运单号:">
                <el-input
                  clearable
                  v-model="queryData2.mainWaybillNumber"
                  @keyup.enter.native="queryBtn_ok"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
              <el-form-item class="queryItems" label="运单状态:">
                <el-select
                  filterable
                  clearable
                  v-model="queryData2.waybillStatus"
                  placeholder="请输入"
                  @change="queryBtn_ok"
                >
                  <el-option
                    v-for="(item, index) in waybillStatusList"
                    :key="index"
                    :label="item.showName"
                    :value="item.statusVal"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="queryItems" label="">
                <el-checkbox v-model="queryData2.isHasTaskNoComplete"
                  >存在待完成仓配任务</el-checkbox
                >
              </el-form-item>

              <!-- <el-form-item class="queryItems" label="配送仓库:">
                <el-select
                  filterable
                  clearable
                  v-model="queryData2.aaaa"
                  placeholder="请输入"
                >
                  <el-option
                    v-for="(item, index) in storageList"
                    :key="index"
                   :label="item.departmentName"
                    :value="item.deptId"
                  ></el-option>
                </el-select>
              </el-form-item> -->

              <!-- <el-button
                v-if="hasPermiss('aaaaa')"
                class="chaXunBtns glo_bgcMainColor"
                @click="getData2"
                >查询
              </el-button>
              <el-button v-if="hasPermiss('aaaaa')" class="chaXunBtns"
                >重置
              </el-button> -->
            </el-form>
          </div>

          <div class="tb">
            <!-- 表格 -->
            <div class="glo_Table tbLeft">
              <el-table
                :height="tableHeigth2"
                header-align="center"
                ref="mytable2"
                @row-click="rowclick2"
                :data="tableData2"
                border
                stripe
                :highlight-current-row="true"
                show-summary
                :summary-method="getSummaries"
                @selection-change="handleSelectionChange2"
              >
                <el-table-column
                  fixed="left"
                  align="center"
                  label="序号"
                  type="index"
                  width="60"
                >
                </el-table-column>
                <el-table-column
                  fixed="left"
                  align="center"
                  type="selection"
                  width="60"
                ></el-table-column>
                <template v-for="(item, index) in myTableHeard2">
                  <el-table-column
                    :key="index"
                    :label="item.name"
                    :prop="item.field"
                    align="center"
                    sortable
                    :show-overflow-tooltip="true"
                    :min-width="item.width"
                    :data-isTotal="item.isTotal"
                    v-if="item && item.isShow"
                  >
                  </el-table-column>
                </template>
              </el-table>

              <!-- 分页 -->
              <paging
                ref="pags"
                :pageNum="pageStart2"
                :total="pageCount2"
                :size="pageTotal2"
                @handleSizeChange="handleSizeChange2"
                @handleCurrentChange="handleCurrentChange2"
              >
              </paging>
            </div>
            <!-- 右边生成任务 -->
            <div class="tbRight" :style="'height:' + tableHeigth">
              <el-form ref="form" :model="rightForm" label-width="100px">
                <el-form-item label="配送仓库:">
                  <el-select
                    filterable
                    clearable
                    v-model="queryData3.storageId"
                    placeholder="请输入"
                    @change="changeStorage"
                  >
                    <el-option
                      v-for="item in storageList"
                      :key="item.deptId"
                      :label="item.departmentName"
                      :value="item.deptId"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="任务运输方式:">
                  <el-radio-group
                    v-model="rightForm.transportMethod"
                    @change="changeType"
                  >
                    <el-radio
                      v-for="(item, index) in transportMethodStatus"
                      :key="index"
                      :label="item.statusVal"
                      >{{ item.showName }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
                <el-form-item
                  label="外部承运商:"
                  v-if="
                    rightForm.transportMethod ===
                    'wai_bu_cheng_yun:transport_method'
                  "
                >
                  <el-select
                    clearable
                    filterable
                    v-model="rightForm.externalCarrierName"
                    placeholder="请选择"
                    @change="changecarrierName"
                  >
                    <el-option
                      v-for="(item, index) in changeCarrierList"
                      :key="index"
                      :label="item.carrierName"
                      :value="item.carrierName"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="运输计划:">
                  <el-radio-group
                    v-model="rightForm.transportPlan"
                    @change="changetransportPlan"
                  >
                    <el-radio
                      v-for="(item, index) in transportPlanList"
                      :key="index"
                      :label="item.statusVal"
                      >{{ item.showName }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
                <el-form-item
                  label="入仓仓库:"
                  v-if="rightForm.transportPlan === 'ru_cang:transport_plan'"
                >
                  <el-select
                    clearable
                    filterable
                    v-model="rightForm.storageId"
                    placeholder="请选择"
                    @change="changeRuCang"
                  >
                    <el-option
                      v-for="(item, index) in storageList"
                      :key="index"
                      :label="item.departmentName"
                      :value="item.deptId"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item
                  label="外发承运商:"
                  v-if="rightForm.transportPlan === 'wai_fa:transport_plan'"
                >
                  <el-select
                    clearable
                    filterable
                    v-model="rightForm.carrierName"
                    placeholder="请选择"
                    @change="changecarrierName2"
                  >
                    <el-option
                      v-for="(item, index) in changeCarrierList"
                      :key="index"
                      :label="item.carrierName"
                      :value="item.carrierName"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  label="外发网点:"
                  v-if="rightForm.transportPlan === 'wai_fa:transport_plan'"
                >
                  <el-select
                    clearable
                    filterable
                    v-model="rightForm.carrierDeptId"
                    placeholder="请选择"
                    @change="changeCarrierDep"
                  >
                    <el-option
                      v-for="(item, index) in CarrierDeptListList"
                      :key="index"
                      :label="item.deptName"
                      :value="item.carrierDeptId"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <div
                  v-if="rightForm.transportPlan === 'zhi_song:transport_plan'"
                >
                  <!-- 直送 -->
                  <el-form-item label="目的地址">
                    <el-input
                      placeholder="对应运单的收货地址"
                      type="text"
                      readonly
                    ></el-input>
                  </el-form-item>
                </div>
                <!-- 目的地 -->
                <div
                  v-if="rightForm.transportPlan !== 'zhi_song:transport_plan'"
                >
                  <el-form-item label="目的地址:">
                    <el-input
                      placeholder="自动获取仓库地址"
                      readonly
                      clearable
                      v-model="rightForm.addressAll"
                      type="textarea"
                    ></el-input>
                  </el-form-item>
                </div>
                <el-form-item label="备注:">
                  <el-input
                    placeholder="请输入"
                    clearable
                    v-model="rightForm.remarks"
                    type="textarea"
                  ></el-input>
                </el-form-item>
              </el-form>

              <div class="rbtns">
                <el-button
                  class="creatPlanBtns glo_bgcMainColor"
                  @click="submitBtns(2)"
                  >生成任务</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <!-- =====外部仓配送===== -->
      <el-tab-pane label="外部仓配送" name="three">
        <div>
          <div ref="queryForm3">
            <!-- 查询条件 -->
            <el-form
              :model="queryData2"
              :class="isHaseMore ? 'glo_form hasMoreParam' : 'glo_form'"
              label-position="left"
            >
              <!-- 时间组件 -->
              <el-form-item class="queryItemsTimes">
                <multitime
                  :timeType="timeType"
                  :timeTypes="timeTypes"
                  :startTime="startTime_a"
                  :endTime="endTime_a"
                  @timestatus="timestatus"
                  @queryBtn_ok="queryBtn_time"
                >
                </multitime>
              </el-form-item>
              <el-form-item class="queryItemsAddress" label="收货地址:">
                <!-- 省 -->
                <el-select
                  style="width: 100px"
                  filterable
                  clearable
                  v-model="queryData2.recipeAddrProvinceName"
                  placeholder="请输入"
                  @change="changeProvinceName2"
                >
                  <el-option
                    v-for="(item, index) in SuperiorRegionList"
                    :key="index"
                    :label="item.districtName"
                    :value="item.districtName"
                  ></el-option>
                </el-select>
                <!-- 市 -->
                <el-select
                  style="width: 100px"
                  filterable
                  clearable
                  v-model="queryData2.recipeAddrCityName"
                  placeholder="请输入"
                  @change="changeCityName2"
                >
                  <el-option
                    v-for="(item, index) in SuperiorRegionList2"
                    :key="index"
                    :label="item.districtName"
                    :value="item.districtName"
                  ></el-option>
                </el-select>
                <!-- 区 -->
                <el-select
                  style="width: 100px"
                  filterable
                  clearable
                  v-model="queryData2.recipeAddrAddress"
                  placeholder="请输入"
                  @change="getParentName($event, 3)"
                >
                  <el-option
                    v-for="(item, index) in SuperiorRegionList3"
                    :key="index"
                    :label="item.districtName"
                    :value="item.districtName"
                  ></el-option>
                </el-select>
                <!-- 详细地址 -->
                <el-input
                  placeholder="请输入详细地址"
                  clearable
                  v-model="queryData2.recipeAddrAddress"
                  @keyup.enter.native="queryBtn_ok"
                ></el-input>
              </el-form-item>

              <el-form-item class="queryItems" label="运单号:">
                <el-input
                  clearable
                  v-model="queryData2.waybillNumber"
                  placeholder="请输入"
                  @keyup.enter.native="queryBtn_ok"
                ></el-input>
              </el-form-item>
              <el-form-item class="queryItems" label="收货人:">
                <el-input
                  clearable
                  v-model="queryData2.recipeContacts"
                  placeholder="请输入"
                  @keyup.enter.native="queryBtn_ok"
                ></el-input>
              </el-form-item>
              <el-form-item class="queryItems" label="客户单号:">
                <el-input
                  clearable
                  v-model="queryData2.customerOrderNumber"
                  placeholder="请输入"
                  @keyup.enter.native="queryBtn_ok"
                ></el-input>
              </el-form-item>
              <el-form-item class="queryItems" label="客户名称:">
                <el-select
                  filterable
                  clearable
                  v-model="queryData2.customerName"
                  placeholder="请输入"
                  remote
                  :remote-method="getCustomerList"
                  @focus="getCustomerList()"
                  @change="queryBtn_ok"
                >
                  <el-option
                    v-for="(item, index) in CustomerLists"
                    :key="index"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="queryItems" label="开单网点:">
                <el-select
                  filterable
                  clearable
                  v-model="queryData2.businessDeptId"
                  placeholder="请输入"
                  @change="queryBtn_ok"
                >
                  <el-option
                    v-for="(item, index) in storageList"
                    :key="index"
                    :label="item.departmentName"
                    :value="item.deptId"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="queryItems" label="终端网点:">
                <el-select
                  filterable
                  clearable
                  v-model="queryData2.endDeptId"
                  placeholder="请输入"
                  @change="queryBtn_ok"
                >
                  <el-option
                    v-for="(item, index) in storageList"
                    :key="index"
                    :label="item.departmentName"
                    :value="item.deptId"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="queryItems" label="运输方式:">
                <el-select
                  filterable
                  clearable
                  v-model="queryData2.transportMethodConfDictId"
                  placeholder="请输入"
                  @focus="getConfDictValDownList('transport_method')"
                  @change="queryBtn_ok"
                >
                  <el-option
                    v-for="(item, index) in transportMethodList"
                    :key="index"
                    :label="item.key"
                    :value="item.confDictId"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="queryItems" label="提货方式:">
                <el-select
                  filterable
                  clearable
                  v-model="queryData2.receiveMethodConfDictId"
                  placeholder="请输入"
                  @focus="getConfDictValDownList('receive_method')"
                  @change="queryBtn_ok"
                >
                  <el-option
                    v-for="(item, index) in receiveMethodList"
                    :key="index"
                    :label="item.key"
                    :value="item.confDictId"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="queryItems" label="送货方式:">
                <el-select
                  filterable
                  clearable
                  v-model="queryData2.sendMethodConfDictId"
                  placeholder="请输入"
                  @focus="getConfDictValDownList('send_method')"
                  @change="queryBtn_ok"
                >
                  <el-option
                    v-for="(item, index) in sendMethodList"
                    :key="index"
                    :label="item.key"
                    :value="item.confDictId"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="queryItems" label="在途状态:">
                <el-select
                  filterable
                  clearable
                  v-model="queryData2.onwayStatus"
                  placeholder="请输入"
                  @change="queryBtn_ok"
                >
                  <el-option
                    v-for="(item, index) in OnwayStatusList"
                    :key="index"
                    :label="item.showName"
                    :value="item.statusVal"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="queryItems" label="当前站点:">
                <el-select
                  filterable
                  clearable
                  v-model="queryData2.currentDeptId"
                  placeholder="请输入"
                  @change="queryBtn_ok"
                >
                  <el-option
                    v-for="(item, index) in storageList"
                    :key="index"
                    :label="item.departmentName"
                    :value="item.deptId"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="queryItems" label="原运单号:">
                <el-input
                  clearable
                  v-model="queryData2.mainWaybillNumber"
                  placeholder="请输入"
                  @keyup.enter.native="queryBtn_ok"
                ></el-input>
              </el-form-item>
              <el-form-item class="queryItems" label="运单状态:">
                <el-select
                  filterable
                  clearable
                  v-model="queryData2.waybillStatus"
                  placeholder="请输入"
                  @change="queryBtn_ok"
                >
                  <el-option
                    v-for="(item, index) in waybillStatusList"
                    :key="index"
                    :label="item.showName"
                    :value="item.statusVal"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="queryItems" label="">
                <el-checkbox v-model="queryData2.isHasTaskNoComplete"
                  >存在待完成仓配任务</el-checkbox
                >
              </el-form-item>
            </el-form>
          </div>
          <!-- <el-form :model="queryData3" class="glo_form" label-position="left">
            <el-form-item class="queryItems" label="承运商:">
              <el-select
                filterable
                clearable
                v-model="queryData3.carrierId"
                placeholder="请输入"
                @change="changecarrierName3"
              >
                <el-option
                  v-for="(item, index) in changeCarrierList"
                  :key="index"
                  :label="item.carrierName"
                  :value="item.carrierId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="queryItems" label="网点:">
              <el-select
                filterable
                clearable
                v-model="queryData3.carrierDeptId"
                placeholder="请输入"
                @change="changeCarrierDeptName"
              >
                <el-option
                  v-for="(item, index) in CarrierDeptListList2"
                  :key="index"
                  :label="item.deptName"
                  :value="item.carrierDeptId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form> -->
          <div class="tb">
            <!-- 表格 -->
            <div class="glo_Table tbLeft">
              <el-table
                :height="tableHeigth3"
                header-align="center"
                ref="mytable3"
                @row-click="rowclick3"
                :data="tableData3"
                border
                stripe
                :highlight-current-row="true"
                show-summary
                :summary-method="getSummaries"
                @selection-change="handleSelectionChange3"
              >
                <el-table-column
                  fixed="left"
                  align="center"
                  label="序号"
                  type="index"
                  width="60"
                >
                </el-table-column>
                <el-table-column
                  fixed="left"
                  align="center"
                  type="selection"
                  width="60"
                ></el-table-column>
                <template v-for="(item, index) in myTableHeard3">
                  <!-- 某个字段需要单独操作  例如点击可以跳转 -->
                  <el-table-column
                    v-if="item.field == 'memberNickname' && item.isShow"
                    :key="index"
                    :label="item.name"
                    :prop="item.field"
                    align="center"
                    sortable
                    :show-overflow-tooltip="true"
                    :min-width="item.width"
                    :data-isTotal="item.isTotal"
                  >
                    <template slot-scope="scope">
                      <div
                        class="linkTabel"
                        @click.stop="goYdDetails(scope.row)"
                      >
                        {{ scope.row.memberNickname }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :key="index"
                    :label="item.name"
                    :prop="item.field"
                    align="center"
                    sortable
                    :show-overflow-tooltip="true"
                    :min-width="item.width"
                    :data-isTotal="item.isTotal"
                    v-else-if="item && item.isShow"
                  >
                  </el-table-column>
                </template>
              </el-table>

              <!-- 分页 -->
              <paging
                ref="pags"
                :pageNum="pageStart3"
                :total="pageCount3"
                :size="pageTotal3"
                @handleSizeChange="handleSizeChange3"
                @handleCurrentChange="handleCurrentChange3"
              >
              </paging>
            </div>
            <!-- 右边生成任务 -->
            <div class="tbRight" :style="'height:' + tableHeigth">
              <el-form ref="form" :model="rightForm" label-width="100px">
                <el-form-item class="queryItems" label="外部仓承运商:">
                  <el-select
                    filterable
                    clearable
                    v-model="queryData3.carrierId"
                    placeholder="请输入"
                    @change="changecarrierName3"
                  >
                    <el-option
                      v-for="(item, index) in changeCarrierList"
                      :key="index"
                      :label="item.carrierName"
                      :value="item.carrierId"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="queryItems" label="外部仓网点:">
                  <el-select
                    filterable
                    clearable
                    v-model="queryData3.carrierDeptId"
                    placeholder="请输入"
                    @change="changeCarrierDeptName"
                  >
                    <el-option
                      v-for="(item, index) in CarrierDeptListList2"
                      :key="index"
                      :label="item.deptName"
                      :value="item.carrierDeptId"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="任务运输方式:">
                  <el-radio-group
                    v-model="rightForm.transportMethod"
                    @change="changeType"
                  >
                    <el-radio
                      v-for="(item, index) in transportMethodStatus"
                      :key="index"
                      :label="item.statusVal"
                      >{{ item.showName }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
                <el-form-item
                  label="外部承运商:"
                  v-if="
                    rightForm.transportMethod ===
                    'wai_bu_cheng_yun:transport_method'
                  "
                >
                  <el-select
                    clearable
                    filterable
                    v-model="rightForm.externalCarrierName"
                    placeholder="请选择"
                    @change="changecarrierName"
                  >
                    <el-option
                      v-for="(item, index) in changeCarrierList"
                      :key="index"
                      :label="item.carrierName"
                      :value="item.carrierName"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="运输计划:">
                  <el-radio-group
                    v-model="rightForm.transportPlan"
                    @change="changetransportPlan"
                  >
                    <el-radio
                      v-for="(item, index) in transportPlanList"
                      :key="index"
                      :label="item.statusVal"
                      >{{ item.showName }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
                <el-form-item
                  label="入仓仓库:"
                  v-if="rightForm.transportPlan === 'ru_cang:transport_plan'"
                >
                  <el-select
                    clearable
                    filterable
                    v-model="rightForm.storageId"
                    placeholder="请选择"
                    @change="changeRuCang"
                  >
                    <el-option
                      v-for="(item, index) in storageList"
                      :key="index"
                      :label="item.departmentName"
                      :value="item.deptId"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item
                  label="外发承运商:"
                  v-if="rightForm.transportPlan === 'wai_fa:transport_plan'"
                >
                  <el-select
                    clearable
                    filterable
                    v-model="rightForm.carrierName"
                    placeholder="请选择"
                    @change="changecarrierName2"
                  >
                    <el-option
                      v-for="(item, index) in changeCarrierList"
                      :key="index"
                      :label="item.carrierName"
                      :value="item.carrierName"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  label="外发网点:"
                  v-if="rightForm.transportPlan === 'wai_fa:transport_plan'"
                >
                  <el-select
                    clearable
                    filterable
                    v-model="rightForm.carrierDeptId"
                    placeholder="请选择"
                    @change="changeCarrierDep"
                  >
                    <el-option
                      v-for="(item, index) in CarrierDeptListList"
                      :key="index"
                      :label="item.deptName"
                      :value="item.carrierDeptId"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <div
                  v-if="rightForm.transportPlan === 'zhi_song:transport_plan'"
                >
                  <!-- 直送 -->
                  <el-form-item label="目的地址">
                    <el-input
                      placeholder="对应运单的收货地址"
                      type="text"
                      readonly
                    ></el-input>
                  </el-form-item>
                </div>
                <!-- 目的地 -->
                <div
                  v-if="rightForm.transportPlan !== 'zhi_song:transport_plan'"
                >
                  <el-form-item label="目的地址:">
                    <el-input
                      placeholder="自动获取仓库地址"
                      readonly
                      clearable
                      v-model="rightForm.addressAll"
                      type="textarea"
                    ></el-input>
                  </el-form-item>
                </div>
                <el-form-item label="备注:">
                  <el-input
                    placeholder="请输入"
                    clearable
                    v-model="rightForm.remarks"
                    type="textarea"
                  ></el-input>
                </el-form-item>
              </el-form>

              <div class="rbtns">
                <el-button
                  class="creatPlanBtns glo_bgcMainColor"
                  @click="submitBtns(3)"
                  >生成任务</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>

    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitleSet"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    >
    </sorttable>
  </div>
</template>
<script>
import multitime from "@/components/multiTime.vue";
import paging from "@/components/pagings.vue"; //分页组件
import myDialog from "@/components/Dialog.vue";
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
export default {
  components: {
    multitime,
    paging,
    myDialog,
    sorttable,
  },
  data() {
    return {
      activeName: "one",
      //  -----  查询  ------
      queryData: {
        businessDeptId: "",
        customerName: "",
        customerOrderNumber: "",
        endBusinessTime: "",
        endCreateTime: "",
        endDeliveryTime: "",
        endDeptId: "",
        endTakeTime: "",
        loadAddrAddress: "",
        loadAddrArea: "",
        loadAddrCityName: "",
        loadAddrProvinceName: "",
        number: "",
        receiveMethodConfDictId: "",
        sendMethodConfDictId: "",
        startBusinessTime: "",
        startCreateTime: "",
        startDeliveryTime: "",
        startTakeTime: "",
        transportMethodConfDictId: "",
        waybillNumber: "",
        outboundCarrierName: "",
        unloadContacts: "",
        unloadCompany: "",
        netWeight: "",
      }, //  表单查询数据
      queryData2: {
        isHasTaskNoComplete: false,
        businessDeptId: "",
        currentDeptId: "",
        customerName: "",
        customerOrderNumber: "",
        endBusinessTime: "",
        endCreateTime: "",
        endDeliveryTime: "",
        endDeptId: "",
        endTakeTime: "",
        mainWaybillNumber: "",
        onwayStatus: "",
        pageStart: "",
        pageTotal: "",
        receiveMethodConfDictId: "",
        recipeAddrAddress: "",
        recipeAddrCityName: "",
        recipeAddrProvinceName: "",
        sendMethodConfDictId: "",
        startBusinessTime: "",
        startCreateTime: "",
        startDeliveryTime: "",
        startTakeTime: "",
        transportMethodConfDictId: "",
        waybillNumber: "",
        waybillStatus: "",
        recipeContacts: "",
      }, //  表单查询数据
      queryData3: {
        carrierDeptId: "",
        carrierDeptName: "",
        carrierId: "",
        carrierName: "",
        storageId: "",
        storageName: "",
      }, //  表单查询数据
      //  时间类型
      timeTypes: [
        {
          value: "0",
          label: "创建日期",
        },
        {
          value: "1",
          label: "业务日期",
        },
        {
          value: "2",
          label: "提货时间",
        },
        {
          value: "3",
          label: "交货日期",
        },
      ],
      timeType: "0", //  时间类型
      startTime_a: "",
      endTime_a: "",

      MoreConditions: "更多条件", //  输入框绑定动态class
      isHaseMore: true, //false == 更多条件  true ==收起条件

      //      -------  表格  ----------
      pageStart1: 1, //  页码
      pageCount1: 0, //  总条数
      pageTotal1: this.$COMMON.pageTotals, //  一页几条
      pageStart2: 1, //  页码
      pageCount2: 0, //  总条数
      pageTotal2: this.$COMMON.pageTotals, //  一页几条
      pageStart3: 1, //  页码
      pageCount3: 0, //  总条数
      pageTotal3: this.$COMMON.pageTotals, //  一页几条
      tableHeigth: "60vh", //  表格高度
      tableHeigth2: "65vh", //  表格高度
      tableHeigth3: "65vh", //  表格高度
      selectTableData: [], //  表格选中的数据
      selectTableData2: [], //  表格选中的数据
      selectTableData3: [], //  表格选中的数据

      show_sortTableHeard: false, //显示表格设置弹窗
      tabelHeadeTitleSet: [],
      originalTabelHeadeTitle: [], //自定义排序表头(恢复默认用)
      originalTabelHeadeTitle1: [],
      originalTabelHeadeTitle2: [],
      originalTabelHeadeTitle3: [],
      allCheck: false, //  全选
      sortName: "", //  排序名
      sortName1: "提货", //  排序名
      sortName2: "内部仓配送", //  排序名
      sortName3: "外部仓配送模板", //  排序名
      selectLength: 0, //  显示的长度

      // 提货表头
      tabelHeadeTitle: [
        {
          name: "运单号",
          field: "waybillNumber",
          width: "190",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "提货单号",
          field: "number",
          width: "200",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "提货状态",
          field: "takeStatusShow",
          width: "106",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "品类",
          field: "itemCategoryName",
          width: "106",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "计费取值",
          field: "billingWeight",
          width: "106",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "毛重",
          field: "grossWeight",
          width: "106",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "净重",
          field: "netWeight",
          width: "106",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "体积(m³)",
          field: "volume",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "规格",
          field: "specs",
          width: "106",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "客户单号",
          field: "customerOrderNumber",
          width: "180",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "客户名称",
          field: "customerName",
          width: "106",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "客户编号",
          field: "customerNumber",
          width: "140",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "提货时间",
          field: "takeTime",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "交货日期",
          field: "deliveryTime",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "装货地址",
          field: "taskStartAllAddress",
          width: "180",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货地址",
          field: "taskEndAllAddress",
          width: "180",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "货物",
          field: "aaaaaa",
          width: "106",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "计划外发承运商",
          field: "outboundCarrierName",
          width: "106",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货人",
          field: "unloadContacts",
          width: "106",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货单位",
          field: "unloadCompany",
          width: "106",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "创建人",
          field: "createUserName",
          width: "106",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "创建时间",
          field: "createTime",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
      ],
      // 内部仓派送表头
      tabelHeadeTitle2: [
        {
          name: "客户编号",
          field: "customerNumber",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "客户名称",
          field: "customerName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "客户单号",
          field: "customereOrderNumber",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "运单号",
          field: "waybillNumber",
          width: "190",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "原运单号",
          field: "mainWaybillNumber",
          width: "190",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },

        {
          name: "运单状态",
          field: "waybillStatusShow",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "提货状态",
          field: "takeStatusShow",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "存在未完成的仓配任务",
          field: "isHasTaskNoCompleteShow",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "最新运输任务状态",
          field: "taskStatusShow",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "在途状态",
          field: "onwayStatusShow",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "当前网点",
          field: "currentDeptName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "业务员",
          field: "businessName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "付款方式",
          field: "settlementMethod",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "是否开票",
          field: "isInvoiceShow",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "开票税点",
          field: "taxes",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "业务时间",
          field: "businessDate",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "目的城市",
          field: "receiveCityName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "终端网点",
          field: "endDeptName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "开单网点",
          field: "aaaaa",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "运输方式",
          field: "transportMethod",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "提货方式",
          field: "receiveMethod",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "送货方式",
          field: "sendMethod",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "回单方式",
          field: "rnRequireName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "回单份数",
          field: "rnRequireCount",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货省",
          field: "receiveProvinceName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货市",
          field: "receiveCityName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货区",
          field: "receiveAreaName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货地址",
          field: "receiveAddress",
          width: "140",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货单位",
          field: "receiveCompany",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货人",
          field: "receiveContacts",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货电话",
          field: "receivePhone",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "提货省",
          field: "takeProvinceName",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "提货市",
          field: "takeCityName",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "提货区县",
          field: "takeAreaName",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "提货地址",
          field: "takeAddress",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "提货地址数量",
          field: "takeAddressCount",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "发货单位",
          field: "takeCompany",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "发货人",
          field: "takeContacts",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "发货电话",
          field: "takePhone",
          width: "130",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "创建时间",
          field: "createTime",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "创建人",
          field: "createUserName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "订单号",
          field: "orderNumber",
          width: "130",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
      ],
      // 外部仓派送表头
      tabelHeadeTitle3: [
        {
          name: "运单号",
          field: "waybillNumber",
          width: "190",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "存在未完成的仓配任务",
          field: "isHasTaskNoCompleteShow",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "提货状态",
          field: "takeStatusShow",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "最新运输任务状态",
          field: "taskStatusShow",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "客户编号",
          field: "customerNumber",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "客户名称",
          field: "customerName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "客户单号",
          field: "customereOrderNumber",
          width: "190",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },

        {
          name: "原运单号",
          field: "mainWaybillNumber",
          width: "190",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },

        {
          name: "运单状态",
          field: "waybillStatusShow",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "在途状态",
          field: "onwayStatusShow",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "当前网点",
          field: "currentDeptName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "业务员",
          field: "businessName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "付款方式",
          field: "settlementMethod",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "是否开票",
          field: "isInvoiceShow",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "开票税点",
          field: "taxes",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "业务时间",
          field: "businessDate",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "目的城市",
          field: "receiveCityName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "终端网点",
          field: "endDeptName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "开单网点",
          field: "aaaaa",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "运输方式",
          field: "transportMethod",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "提货方式",
          field: "receiveMethod",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "送货方式",
          field: "sendMethod",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "回单方式",
          field: "rnRequireName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "回单份数",
          field: "rnRequireCount",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货省",
          field: "receiveProvinceName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货市",
          field: "receiveCityName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货区",
          field: "receiveAreaName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货地址",
          field: "receiveAddress",
          width: "140",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货地址",
          field: "receiveAddress",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货单位",
          field: "receiveCompany",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货人",
          field: "receiveContacts",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货电话",
          field: "receivePhone",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "提货省",
          field: "takeProvinceName",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "提货市",
          field: "takeCityName",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "提货区县",
          field: "takeAreaName",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "提货地址",
          field: "takeAddress",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "提货地址数量",
          field: "takeAddressCount",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "发货单位",
          field: "takeCompany",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "发货人",
          field: "takeContacts",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "发货电话",
          field: "takePhone",
          width: "130",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "创建时间",
          field: "createTime",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "创建人",
          field: "createUserName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "订单号",
          field: "orderNumber",
          width: "130",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
      ],

      myTableHeard: [], //  我的表头(提货)
      myTableHeard2: [], //  我的表头(内部
      myTableHeard3: [], //  我的表头(外部仓)

      tableData: [], //  表格数据
      tableData2: [], //  表格数据
      tableData3: [], //  表格数据

      totalArr: [], //  表格需要合计的字段
      className: "", //  导出需要
      pageGroupName1: "AddTransportationPlan1", //  页面标识
      pageGroupName2: "AddTransportationPlan2", //  页面标识
      pageGroupName3: "AddTransportationPlan3", //  页面标识

      rightForm: {
        transportMethod: "qi_yun_pai_che:transport_method",
        transportPlan: "zhi_song:transport_plan",
        carrierId: "",
        carrierName: "",
        externalCarrierName: "",
        externalCarrierId: "",
        address: "",
        areaName: "",
        carrierDeptId: "",
        carrierDeptName: "",
        carrierId: "",
        cityName: "",
        company: "",
        contacts: "",
        phone: "",
        provinceName: "",
        remarks: "",
        storageId: "",
        storageName: "",
        tel: "",
        addressAll: "",
      },

      transportMethodList: [], //运输方式
      receiveMethodList: [], //提货方式
      sendMethodList: [], //
      storageList: [], //网点列表
      CarrierDeptListList: [], //承运商网点列表
      CarrierDeptListList2: [], //登录账号的承运商网点
      CustomerLists: [], //客户列表
      SuperiorRegionList: [], //省
      SuperiorRegionList2: [], //市
      SuperiorRegionList3: [], //区

      transportMethodStatus: [], //运输方式(状态)
      transportPlanList: [], //运输计划(状态)
      changeCarrierList: [], //承运商列表
      OnwayStatusList: [],
      waybillStatusList: [], //运单状态

      isclickOne: true, //标识=<第一次点内部舱执行
      isclickOne3: true, //标识=<第一次点外部舱执行
    };
  },
  watch: {
    "rightForm.transportPlan": function (a, b) {
      console.log("计划: ", a);
      if (a == "zhi_song:transport_plan") {
        // 直送
      }
      if (a == "wai_fa:transport_plan") {
        // 外发
      }
      if (a == "ru_cang:transport_plan") {
        // 入仓
      }
    },
  },
  created() {
    this.myTableHeard = this.tabelHeadeTitle;

    this.originalTabelHeadeTitle1 = JSON.parse(
      JSON.stringify(this.tabelHeadeTitle)
    );
    this.originalTabelHeadeTitle2 = JSON.parse(
      JSON.stringify(this.tabelHeadeTitle2)
    );
    this.originalTabelHeadeTitle3 = JSON.parse(
      JSON.stringify(this.tabelHeadeTitle3)
    );

    this.startTime_a = this.$TOOLS.getFlexDate(this.$COMMON.timeNum); //开始时间;
    this.endTime_a = this.$TOOLS.getCurrentDate(); //今天的时间;

    let groupNames = this.pageGroupName1;
    if (this.activeName == "two") {
      groupNames = this.pageGroupName2;
    } else if (this.activeName == "three") {
      groupNames = this.pageGroupName3;
    }
    this.getGroupFindFieldSort(groupNames);
  },
  mounted() {
    this.getData1();

    // this.getObjectUserDownList("storage"); //获取网点列表
    this.getDeptList(); //获取仓库列表
    this.getParentName("中华人民共和国", 1);
    this.getStatusValList("bill_tms_transport_task_v3.transport_plan"); //运输计划
    this.getStatusValList("bill_tms_transport_task_v3.transport_method"); //运输方式
    this.getStatusValList("bill_tms_waybill_split_v3.waybill_status"); //运单状态

    this.changeCarrier(); //承运商列表
  },
  activated() {},
  destroyed() {},
  methods: {
    //  设置模板按钮
    myModel() {
      let that = this;

      let tabelHeadeTitleSet = [];
      if (this.activeName == "one") {
        tabelHeadeTitleSet = JSON.parse(JSON.stringify(that.myTableHeard));
        this.originalTabelHeadeTitle = this.originalTabelHeadeTitle1;
        this.sortName = this.sortName1;
      } else if (this.activeName == "two") {
        tabelHeadeTitleSet = JSON.parse(JSON.stringify(that.myTableHeard2));
        this.originalTabelHeadeTitle = this.originalTabelHeadeTitle2;
        this.sortName = this.sortName2;
      } else if (this.activeName == "three") {
        tabelHeadeTitleSet = JSON.parse(JSON.stringify(that.myTableHeard3));
        this.originalTabelHeadeTitle = this.originalTabelHeadeTitle3;
        this.sortName = this.sortName3;
      }

      let selectLength = 0;
      for (var i = 0; i < tabelHeadeTitleSet.length; i++) {
        if (tabelHeadeTitleSet[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
      if (selectLength === tabelHeadeTitleSet.length) {
        that.allCheck = true;
      } else {
        that.allCheck = false;
      }
      that.tabelHeadeTitleSet = tabelHeadeTitleSet;
      that.show_sortTableHeard = true;
    },

    changeStorage(e) {
      console.log(e);
      this.storageList.forEach((item) => {
        if (item.deptId == e) {
          this.queryData3.storageName = item.departmentName;
        }
      });
    },
    // 生成任务
    submitBtns(type) {
      console.log("rightForm", this.rightForm);
      let endAddrReq = JSON.parse(JSON.stringify(this.rightForm)) || {};

      // 提货地址
      let startAddrReq = {
        carrierDeptId: "",
        carrierDeptName: "",
        carrierId: "",
        carrierName: "",
        storageId: "",
        storageName: "",
      };
      if (type == 2) {
        // 内部仓配送
        if (!this.queryData3.storageId) {
          this.$message.error("请选择配送仓库");
          return false;
        }
        startAddrReq.storageId = this.queryData3.storageId;
        startAddrReq.storageName = this.queryData3.storageName;
        startAddrReq.carrierDeptId = "";
        startAddrReq.carrierDeptName = "";
        startAddrReq.carrierId = "";
        startAddrReq.carrierName = "";
      } else if (type == 3) {
        // 外部仓配送
        if (!this.queryData3.carrierId) {
          this.$message.error("请选择承运商");
          return false;
        }
        if (!this.queryData3.carrierDeptId) {
          this.$message.error("请选择承运商网点");
          return false;
        }

        startAddrReq.storageId = "";
        startAddrReq.storageName = "";
        startAddrReq.carrierDeptId = this.queryData3.carrierDeptId;
        startAddrReq.carrierDeptName = this.queryData3.carrierDeptName;
        startAddrReq.carrierId = this.queryData3.carrierId;
        startAddrReq.carrierName = this.queryData3.carrierName;
      }
      let waybillIdReqs = [];

      let transportType = "";
      let wayBillListArray = [];
      // 提货
      if (this.activeName == "one") {
        transportType = "ti_huo:transport_type";
        wayBillListArray = this.selectTableData;
      } else if (this.activeName == "two") {
        transportType = "nei_bu_cang_pei_song:transport_type";
        wayBillListArray = this.selectTableData2;
      } else if (this.activeName == "three") {
        transportType = "wai_bu_cang_pei_song:transport_type";
        wayBillListArray = this.selectTableData3;
      }

      if (wayBillListArray.length < 1) {
        this.$message.warning("请选择需要运输规划的运单").showClose = true;
        return false;
      } else {
        //
        if (this.activeName == "one") {
          wayBillListArray.forEach((item) => {
            let objs = {
              addrId: item.addrId || "",
              waybillSplitId: item.waybillId || "",
            };
            waybillIdReqs.push(objs);
          });
        } else {
          wayBillListArray.forEach((item) => {
            let objs = {
              addrId: item.addrId || "",
              waybillSplitId: item.waybillSplitId || "",
            };
            waybillIdReqs.push(objs);
          });
        }
      }

      let param = {
        endAddrReq: endAddrReq, //目的地址
        startAddrReq: startAddrReq, //提货地址(仓配送时有值)
        waybillIdReqs: waybillIdReqs, //运单信息
        transportType: transportType, //运输类型
      };

      this.$API.wtl_createTask(param).then((res) => {
        this.$message.success(
          res.data.message || "生成任务成功"
        ).showClose = true;
        if (this.activeName == "one") {
          this.getData1();
        }
        if (this.activeName == "two") {
          this.getData2();
        }
        if (this.activeName == "three") {
          this.getData3();
        }
      });
    },
    // 承运商列表
    changeCarrier(e) {
      this.$COMAPI.changeCarrier(e).then((res) => {
        this.changeCarrierList = res || [];
      });
    },
    // 登录账号的承运商(外部)
    changecarrierName3(e) {
      if (e) {
        this.changeCarrierList.forEach((item) => {
          if (item.carrierId == e) {
            this.queryData3.carrierName = item.carrierName;
            this.getCarrierDeptList2(e);
          }
        });
      } else {
        this.queryData3.carrierName = "";
        this.queryData3.carrierDeptName = "";
        this.queryData3.carrierDeptId = "";
      }
    },
    // 登录账号的承运商默认网点
    changeCarrierDeptName(e) {
      if (e) {
        this.CarrierDeptListList2.forEach((item) => {
          if (item.carrierDeptId == e) {
            this.queryData3.carrierDeptName = item.deptName;
          }
        });
      } else {
        this.queryData3.carrierDeptName = "";
      }
    },
    // 选择承运商(外部)
    changecarrierName(e) {
      if (e) {
        this.changeCarrierList.forEach((item) => {
          if (item.carrierName == e) {
            this.rightForm.externalCarrierId = item.carrierId;
          }
        });
      }
    },
    // 选择承运商(外发)
    changecarrierName2(e) {
      if (e) {
        this.changeCarrierList.forEach((item) => {
          if (item.carrierName == e) {
            this.rightForm.carrierId = item.carrierId;
            this.getCarrierDeptList(item.carrierId);
          }
        });
      } else {
        this.rightForm.carrierDeptId = "";
        this.rightForm.carrierId = "";
        this.rightForm.addressAll = "";
      }
    },

    // 选择省
    changeProvinceName(e) {
      this.queryData.loadAddrCityName = "";
      this.queryData.loadAddrArea = "";
      this.queryData.loadAddrAddress = "";
      if (e) {
        this.getParentName(e, 2);
      }
      this.queryBtn_ok();
    },
    // 选择市
    changeCityName(e) {
      this.queryData.loadAddrArea = "";
      this.queryData.loadAddrAddress = "";
      if (e) {
        this.getParentName(e, 3);
      }
      this.queryBtn_ok();
    },
    // 选择省
    changeProvinceName2(e) {
      this.queryData2.recipeAddrCityName = "";
      this.queryData2.recipeAddrArea = "";
      this.queryData2.recipeAddrAddress = "";
      if (e) {
        this.getParentName(e, 2);
      }
      this.queryBtn_ok();
    },
    // 选择市
    changeCityName2(e) {
      this.queryData2.recipeAddrArea = "";
      this.queryData2.recipeAddrAddress = "";
      if (e) {
        this.getParentName(e, 3);
      }
      this.queryBtn_ok();
    },

    // 根据上级名称查询省市区
    getParentName(name, num) {
      this.$COMAPI.getParentName(name).then((res) => {
        if (num == 1) {
          this.SuperiorRegionList = res || [];
        } else if (num == 2) {
          this.SuperiorRegionList2 = res || [];
        } else if (num == 3) {
          this.SuperiorRegionList3 = res || [];
        }
      });
    },
    // 客户列表
    getCustomerList(name) {
      this.$COMAPI.getCustomerList(name).then((res) => {
        this.CustomerLists = res || [];
      });
    },
    // 各种状态下拉列表接口
    getStatusValList(type) {
      this.$TOOLS.getStatusValList(type).then((res) => {
        // 运输方式
        if (type == "bill_tms_transport_task_v3.transport_method") {
          this.transportMethodStatus = res || [];
        }
        // 运输计划
        if (type == "bill_tms_transport_task_v3.transport_plan") {
          this.transportPlanList = res || [];
        }
        // 运输计划
        if (type == "bill_tms_waybill_split_v3.waybill_status") {
          this.waybillStatusList = res || [];
        }
      });
    },
    // 根据对象类型获取对象的下拉列表
    // getObjectUserDownList(type) {
    //   this.$COMAPI.getObjectUserDownList(type).then((res) => {
    //     if (type == "storage") {
    //       //获取网点列表
    //       this.storageList = res || [];
    //     }
    //   });
    // },
    // 获取仓库列表
    getDeptList() {
      let param = {
        pageStart: 1,
        pageTotal: 200,
        isStorage: "1",
      };
      this.$API.wtl_getDeptList(param).then((res) => {
        this.storageList = res.data.result.data || [];

        // 登录账号的信息
        let userdata = this.$TOOLS.getUserInfo() || "";
        if (userdata) {
          console.log("userdata", userdata);
          // userdata = JSON.parse(userdata);
          this.storageList.forEach((item) => {
            if (userdata.departmentId == item.deptId) {
              this.queryData3.storageId = userdata.departmentId || "";
              this.queryData3.storageName = userdata.storageName || "";
            }
          });
        }
      });
    },
    // 选择运输方式
    changetransportPlan(e) {
      console.log("e", e);

      this.rightForm.address = "";
      this.rightForm.areaName = "";
      this.rightForm.cityName = "";
      this.rightForm.provinceName = "";
      this.rightForm.addressAll = "";

      this.rightForm.carrierDeptId = "";
      this.rightForm.storageId = "";
    },
    // 选择外发网点获取地址
    changeCarrierDep(e) {
      if (e) {
        this.CarrierDeptListList.forEach((item) => {
          if (item.carrierDeptId == e) {
            this.rightForm.address = item.address || "";
            this.rightForm.areaName = item.areaName || "";
            this.rightForm.cityName = item.cityName || "";
            this.rightForm.provinceName = item.provinceName || "";
            this.rightForm.addressAll =
              item.provinceName + item.cityName + item.areaName + item.address;
          }
        });
      } else {
        this.rightForm.address = "";
        this.rightForm.areaName = "";
        this.rightForm.cityName = "";
        this.rightForm.provinceName = "";
        this.rightForm.addressAll = "";
      }
    },
    // 选择入仓仓库
    changeRuCang(e) {
      console.log("e", e);
      if (e) {
        this.storageList.forEach((item) => {
          if (item.deptId == e) {
            this.rightForm.storageName = item.departmentName || "";

            this.rightForm.address = item.address || "";
            this.rightForm.areaName = item.areaName || "";
            this.rightForm.cityName = item.cityName || "";
            this.rightForm.provinceName = item.provinceName || "";
            this.rightForm.addressAll =
              item.provinceName + item.cityName + item.areaName + item.address;
          }
        });
      } else {
        this.rightForm.address = "";
        this.rightForm.areaName = "";
        this.rightForm.cityName = "";
        this.rightForm.provinceName = "";
        this.rightForm.addressAll = "";
      }
    },
    // 获取承运商网点
    getCarrierDeptList(id) {
      this.$COMAPI.CarrierDeptList(id).then((res) => {
        this.CarrierDeptListList = res || [];
      });
    },
    // 获取承运商网点
    getCarrierDeptList2(id) {
      this.$COMAPI.CarrierDeptList(id).then((res) => {
        this.CarrierDeptListList2 = res || [];
        if (this.CarrierDeptListList2.length > 0) {
          this.queryData3.carrierDeptId =
            this.CarrierDeptListList2[0].carrierDeptId;
          this.queryData3.carrierDeptName =
            this.CarrierDeptListList2[0].deptName;
        }
      });
    },

    //
    // 根据字典类型获取字典值下拉列表
    getConfDictValDownList(type) {
      this.$COMAPI.getConfDictValDownList(type).then((res) => {
        if (type == "transport_method") {
          //运输方式
          this.transportMethodList = res || [];
        }
        if (type == "receive_method") {
          //提货方式
          this.receiveMethodList = res || [];
        }
        if (type == "send_method") {
          //送货方式
          this.sendMethodList = res || [];
        }
      });
    },
    // 提货
    getData1() {
      let param1 = JSON.parse(JSON.stringify(this.queryData));
      param1.pageStart = this.pageStart1;
      param1.pageTotal = this.pageTotal1;

      let endBusinessTime = "";
      let endCreateTime = "";
      let endDeliveryTime = "";
      let endTakeTime = "";

      let startBusinessTime = "";
      let startCreateTime = "";
      let startDeliveryTime = "";
      let startTakeTime = "";

      let startTime = this.startTime_a ? this.startTime_a + " 00:00:00" : "";
      let endTime = this.endTime_a ? this.endTime_a + " 23:59:59" : "";
      if (this.timeType == 0) {
        startCreateTime = startTime;
        endCreateTime = endTime;
      }
      if (this.timeType == 1) {
        startBusinessTime = startTime;
        endBusinessTime = endTime;
      }
      if (this.timeType == 2) {
        startTakeTime = startTime;
        endTakeTime = endTime;
      }
      if (this.timeType == 3) {
        startDeliveryTime = startTime;
        endDeliveryTime = endTime;
      }
      param1.endBusinessTime = endBusinessTime;
      param1.endCreateTime = endCreateTime;
      param1.endDeliveryTime = endDeliveryTime;
      param1.endTakeTime = endTakeTime;
      param1.startBusinessTime = startBusinessTime;
      param1.startCreateTime = startCreateTime;
      param1.startDeliveryTime = startDeliveryTime;
      param1.startTakeTime = startTakeTime;

      this.$API.wtl_getWaybillTakeAddrList(param1).then((res) => {
        this.tableData = res.data.result.data || [];
        this.pageCount1 = res.data.result.pageCount;
        this.$nextTick(() => {
          this.fetTableHeight();
        });
      });
    },
    // 内部
    getData2() {
      let param2 = JSON.parse(JSON.stringify(this.queryData2));
      param2.isHasTaskNoComplete = param2.isHasTaskNoComplete ? "1" : "0";
      param2.pageStart = this.pageStart2;
      param2.pageTotal = this.pageTotal2;

      let endBusinessTime = "";
      let endCreateTime = "";
      let endDeliveryTime = "";
      let endTakeTime = "";

      let startBusinessTime = "";
      let startCreateTime = "";
      let startDeliveryTime = "";
      let startTakeTime = "";

      let startTime = this.startTime_a ? this.startTime_a + " 00:00:00" : "";
      let endTime = this.endTime_a ? this.endTime_a + " 23:59:59" : "";
      if (this.timeType == 0) {
        startCreateTime = startTime;
        endCreateTime = endTime;
      }
      if (this.timeType == 1) {
        startBusinessTime = startTime;
        endBusinessTime = endTime;
      }
      if (this.timeType == 2) {
        startTakeTime = startTime;
        endTakeTime = endTime;
      }
      if (this.timeType == 3) {
        startDeliveryTime = startTime;
        endDeliveryTime = endTime;
      }
      param2.endBusinessTime = endBusinessTime;
      param2.endCreateTime = endCreateTime;
      param2.endDeliveryTime = endDeliveryTime;
      param2.endTakeTime = endTakeTime;
      param2.startBusinessTime = startBusinessTime;
      param2.startCreateTime = startCreateTime;
      param2.startDeliveryTime = startDeliveryTime;
      param2.startTakeTime = startTakeTime;

      this.$API.wtl_getWaybillToDoTaskList(param2).then((res) => {
        this.tableData2 = res.data.result.data || [];
        this.pageCount2 = res.data.result.pageCount;
        this.$nextTick(() => {
          this.fetTableHeight();
        });
      });
    },

    // 外部
    getData3() {
      let param3 = JSON.parse(JSON.stringify(this.queryData2));
      param3.isHasTaskNoComplete = param3.isHasTaskNoComplete ? "1" : "0";
      param3.pageStart = this.pageStart3;
      param3.pageTotal = this.pageTotal3;

      let endBusinessTime = "";
      let endCreateTime = "";
      let endDeliveryTime = "";
      let endTakeTime = "";

      let startBusinessTime = "";
      let startCreateTime = "";
      let startDeliveryTime = "";
      let startTakeTime = "";

      let startTime = this.startTime_a ? this.startTime_a + " 00:00:00" : "";
      let endTime = this.endTime_a ? this.endTime_a + " 23:59:59" : "";
      if (this.timeType == 0) {
        startCreateTime = startTime;
        endCreateTime = endTime;
      }
      if (this.timeType == 1) {
        startBusinessTime = startTime;
        endBusinessTime = endTime;
      }
      if (this.timeType == 2) {
        startTakeTime = startTime;
        endTakeTime = endTime;
      }
      if (this.timeType == 3) {
        startDeliveryTime = startTime;
        endDeliveryTime = endTime;
      }
      param3.endBusinessTime = endBusinessTime;
      param3.endCreateTime = endCreateTime;
      param3.endDeliveryTime = endDeliveryTime;
      param3.endTakeTime = endTakeTime;
      param3.startBusinessTime = startBusinessTime;
      param3.startCreateTime = startCreateTime;
      param3.startDeliveryTime = startDeliveryTime;
      param3.startTakeTime = startTakeTime;

      this.$API.wtl_getWaybillToDoTaskList(param3).then((res) => {
        this.tableData3 = res.data.result.data || [];
        this.pageCount3 = res.data.result.pageCount;
        this.$nextTick(() => {
          this.fetTableHeight();
        });
      });
    },
    // 选择运输方式
    changeType(e) {
      // if (e == "wai_bu_cheng_yun:transport_method") {
      //   this.rightForm.transportPlan = "wai_fa:transport_plan";
      // }
    },

    // 获取在途状态
    getOnwayStatus() {
      this.$TOOLS
        .getStatusValList("bill_tms_waybill_split_v3.onway_status")
        .then((res) => {
          this.OnwayStatusList = res || [];
        });
    },
    // 点击tabs切换
    tabsClick(e) {
      if (e.name == "one") {
        this.pageStart1 = 1;
        this.myTableHeard = this.tabelHeadeTitle;
        // this.getData1();
      } else if (e.name == "two") {
        this.pageStart2 = 1;
        this.myTableHeard2 = this.tabelHeadeTitle2;

        if (this.isclickOne) {
          // 只执行一次
          this.isclickOne = false;
          this.getOnwayStatus(); // 获取在途状态
          this.getGroupFindFieldSort(this.pageGroupName2);
        }
      } else if (e.name == "three") {
        this.pageStart3 = 1;
        this.myTableHeard3 = this.tabelHeadeTitle3;

        if (this.isclickOne3) {
          this.isclickOne = false;
          this.getOnwayStatus(); //
          this.getGroupFindFieldSort(this.pageGroupName3);
        }
      }
    },
    queryBtn_ok() {
      //  查询按钮
      if (this.activeName == "one") {
        this.pageStart1 = 1;
        this.myTableHeard = this.tabelHeadeTitle;
        this.getData1();
      } else if (this.activeName == "two") {
        this.pageStart2 = 1;
        this.myTableHeard2 = this.tabelHeadeTitle2;
        this.getData2();
      } else if (this.activeName == "three") {
        this.pageStart3 = 1;
        this.myTableHeard3 = this.tabelHeadeTitle3;
        this.getData3();
      }
    },

    //  重置按钮
    clerBtns() {
      this.startTime_a = "";
      this.endTime_a = "";
      if (this.activeName == "one") {
        this.queryData = {
          businessDeptId: "",
          customerName: "",
          customerOrderNumber: "",
          endBusinessTime: "",
          endCreateTime: "",
          endDeliveryTime: "",
          endDeptId: "",
          endTakeTime: "",
          loadAddrAddress: "",
          loadAddrArea: "",
          loadAddrCityName: "",
          loadAddrProvinceName: "",
          number: "",
          receiveMethodConfDictId: "",
          sendMethodConfDictId: "",
          startBusinessTime: "",
          startCreateTime: "",
          startDeliveryTime: "",
          startTakeTime: "",
          transportMethodConfDictId: "",
          waybillNumber: "",
          unloadContacts: "",
          outboundCarrierName: "",
          unloadCompany: "",
          netWeight: "",
        };
        this.pageStart1 = 1;
        this.myTableHeard = this.tabelHeadeTitle;
        this.getData1();
      } else if (this.activeName == "two") {
        this.queryData2 = {
          isHasTaskNoComplete: false,
          businessDeptId: "",
          currentDeptId: "",
          customerName: "",
          customerOrderNumber: "",
          endBusinessTime: "",
          endCreateTime: "",
          endDeliveryTime: "",
          endDeptId: "",
          endTakeTime: "",
          mainWaybillNumber: "",
          onwayStatus: "",
          pageStart: "",
          pageTotal: "",
          receiveMethodConfDictId: "",
          recipeAddrAddress: "",
          recipeAddrCityName: "",
          recipeAddrProvinceName: "",
          sendMethodConfDictId: "",
          startBusinessTime: "",
          startCreateTime: "",
          startDeliveryTime: "",
          startTakeTime: "",
          transportMethodConfDictId: "",
          waybillNumber: "",
          waybillStatus: "",
          recipeContacts: "",
        };
        this.pageStart2 = 1;
        this.myTableHeard2 = this.tabelHeadeTitle2;
        this.getData2();
      } else if (this.activeName == "three") {
        this.queryData2 = {
          isHasTaskNoComplete: false,
          businessDeptId: "",
          currentDeptId: "",
          customerName: "",
          customerOrderNumber: "",
          endBusinessTime: "",
          endCreateTime: "",
          endDeliveryTime: "",
          endDeptId: "",
          endTakeTime: "",
          mainWaybillNumber: "",
          onwayStatus: "",
          pageStart: "",
          pageTotal: "",
          receiveMethodConfDictId: "",
          recipeAddrAddress: "",
          recipeAddrCityName: "",
          recipeAddrProvinceName: "",
          sendMethodConfDictId: "",
          startBusinessTime: "",
          startCreateTime: "",
          startDeliveryTime: "",
          startTakeTime: "",
          transportMethodConfDictId: "",
          waybillNumber: "",
          waybillStatus: "",
          recipeContacts: "",
        };
        this.pageStart3 = 1;
        this.myTableHeard3 = this.tabelHeadeTitle3;
        this.getData3();
      }
    },

    moreParam() {
      // this.isHaseMore = !this.isHaseMore;
      // if (this.isHaseMore) {
      //   this.MoreConditions = "收起条件";
      // } else {
      //   this.MoreConditions = "更多条件";
      // }
      // this.$nextTick(() => {
      //   this.fetTableHeight();
      // });
    },

    handleSizeChange1(val) {
      //  分页
      this.pageTotal1 = val;
      this.getData1();
    },
    handleCurrentChange1(val) {
      //  分页
      this.pageStart1 = val;
      this.getData1();
    },
    handleSizeChange2(val) {
      //  分页
      this.pageTotal2 = val;
      this.getData2();
    },
    handleCurrentChange2(val) {
      //  分页
      this.pageStart2 = val;
      this.getData2();
    },
    handleSizeChange3(val) {
      //  分页
      this.pageTotal3 = val;
      this.getData3();
    },
    handleCurrentChange3(val) {
      //  分页
      this.pageStart3 = val;
      this.getData3();
    },

    // 时间组件 选择时间后触发
    queryBtn_time(s, e) {
      this.startTime_a = s || "";
      this.endTime_a = e || "";
    },
    // 时间组件 选择类型后触发
    timestatus(type, s, e) {
      this.timeType = type || "0";
      this.startTime_a = s || "";
      this.endTime_a = e || "";
    },

    /***
     * ==============设置表格动态高度==============
     */
    fetTableHeight() {
      // 重置table高度
      this.tabelHeigth = 0;
      // 设置table高度
      let windonHeight =
        document.body.clientHeight || document.documentElement.clientHeight; //页面高度
      let queryHeigth = 40 + 10; //10==margin-top: 10  查询框高度
      // let btnListHeight = this.$refs.btnList.offsetHeight; // 按钮列表高度
      if (this.isHaseMore) {
        if (this.activeName == "one") {
          queryHeigth = this.$refs.queryForm.offsetHeight + 10; //查询框
        } else if (this.activeName == "two") {
          queryHeigth = this.$refs.queryForm2.offsetHeight + 10; //查询框
        } else if (this.activeName == "three") {
          queryHeigth = this.$refs.queryForm3.offsetHeight + 10; //查询框
        }
      }
      let tabsHeight = 50;
      let pagsHeigth = 40 + 20; //分页组件高度 20是上下margin
      var otherHeight = queryHeigth + pagsHeigth + tabsHeight + 60; //60是顶部导航 10是
      let tabHeight = Math.floor(windonHeight - otherHeight) || ""; //
      this.$nextTick(() => {
        if (this.activeName == "one") {
          this.tableHeigth = tabHeight;
          this.$refs.mytable.doLayout();
        } else if (this.activeName == "two") {
          this.tableHeigth2 = tabHeight;
          this.$refs.mytable2.doLayout();
        } else if (this.activeName == "three") {
          this.tableHeigth3 = tabHeight;
          this.$refs.mytable3.doLayout();
        }
        this.$refs.mytable.doLayout();
      });
    },

    // 点击选中当前行
    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row);
    },
    // 点击选中当前行
    rowclick2(row, event, column) {
      this.$refs.mytable2.toggleRowSelection(row);
    },
    // 点击选中当前行
    rowclick3(row, event, column) {
      this.$refs.mytable3.toggleRowSelection(row);
    },

    // 表格合计
    getSummaries(param) {
      let that = this;
      const { columns, data } = param;

      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        for (var i = 0; i < that.totalArr.length; i++) {
          if (column.property === that.totalArr[i]) {
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return this.$TOOLS.mathToFixed(
                    this.$TOOLS.add(prev, curr),
                    2
                  );
                } else {
                  return prev;
                }
              }, 0);
              sums[index] += "";
            } else {
              sums[index] = "---";
            }
          }
        }
      });
      this.$nextTick(() => {
        // this.$refs.mytable.doLayout();
        if (this.activeName == "one") {
          this.$refs.mytable.doLayout();
        } else if (this.activeName == "two") {
          this.$refs.mytable2.doLayout();
        } else if (this.activeName == "three") {
          this.$refs.mytable3.doLayout();
        }
      });
      return sums;
    },

    handleSelectionChange(e) {
      // 表格选择事件
      this.selectTableData = e;
      console.log(this.selectTableData);
    },
    handleSelectionChange2(e) {
      // 表格选择事件
      this.selectTableData2 = e;
    },
    handleSelectionChange3(e) {
      // 表格选择事件
      this.selectTableData3 = e;
    },

    /****
     *  ===================上面页面公共方法 end ===================
     *
     */
    // ===================排序表头彈窗的组件方法 start ===================
    //   取消按钮(表格设置)
    cancelSortHeard() {
      this.show_sortTableHeard = false;
      this.$nextTick(() => {
        if (this.activeName == "one") {
          this.$refs.mytable.doLayout();
        } else if (this.activeName == "two") {
          this.$refs.mytable2.doLayout();
        } else if (this.activeName == "three") {
          this.$refs.mytable3.doLayout();
        }
      });
    },
    // 排序==>确认按钮(表格设置)
    confirmOk(e) {
      this.tabelHeadeTitleSet = e;
      this.myTableHeard = this.tabelHeadeTitleSet;
      let sortObject = this.myTableHeard;
      let param = {};
      if (this.activeName == "one") {
        param = {
          groupName: this.pageGroupName1, //当前页面表格的标记(自定义字符串)
          sortName: this.sortName1, //综合查询接口路径
          sortObject: JSON.stringify(sortObject),
        };
      } else if (this.activeName == "two") {
        param = {
          groupName: this.pageGroupName2, //当前页面表格的标记(自定义字符串)
          sortName: this.sortName2, //综合查询接口路径
          sortObject: JSON.stringify(sortObject),
        };
      } else if (this.activeName == "three") {
        param = {
          groupName: this.pageGroupName3, //当前页面表格的标记(自定义字符串)
          sortName: this.sortName3, //综合查询接口路径
          sortObject: JSON.stringify(sortObject),
        };
      }

      this.$API.pushFindFieldSort(param).then((res) => {
        this.$message.success(res.data.message || "操作成功");
        //获取默认表头
        this.getGroupFindFieldSort(param.groupName);
      });
      this.show_sortTableHeard = false; //关闭弹窗
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
      this.show_sortTableHeard = false;
    },
    // 点击某一项(表格设置)
    checktab(idx, e) {
      let that = this;
      that.tabelHeadeTitleSet[idx].isShow = e;
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitleSet.length; i++) {
        if (that.tabelHeadeTitleSet[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
      if (selectLength == that.tabelHeadeTitleSet.length) {
        that.allCheck = true;
      } else {
        that.allCheck = false;
      }
    },
    //全选(表格设置)
    checkAll(e) {
      let that = this;
      this.allCheck = e;
      for (var j = 0; j < this.tabelHeadeTitleSet.length; j++) {
        this.tabelHeadeTitleSet[j].isShow = e;
      }
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitleSet.length; i++) {
        if (that.tabelHeadeTitleSet[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
    },
    //关闭弹窗(表格设置)
    closeDias(e) {
      this.show_sortTableHeard = e;
    },

    //    -------------  设置列表表头方法  ------------

    getGroupFindFieldSort(pageGroupName) {
      //  获取自定义的排序,没有就用默认的
      this.$API
        .getGroupFindFieldSort({
          groupName: pageGroupName, //当前页面表格的标记(自定义字符串)
        })
        .then((res) => {
          let arr = res.data.result || [];
          let arrs = [];
          if (arr.length > 0) {
            if (arr[0].sortObject) {
              arrs = JSON.parse(arr[0].sortObject);
              console.log("arrsaaaa", arrs);

              if (this.activeName == "one") {
                this.sortName1 = arr[0].sortName;
                this.tabelHeadeTitle = arrs;
              } else if (this.activeName == "two") {
                this.sortName2 = arr[0].sortName;
                this.tabelHeadeTitle2 = arrs;
              } else if (this.activeName == "three") {
                this.sortName3 = arr[0].sortName;
                this.tabelHeadeTitle3 = arrs;
              }
            }
          } else {
            if (this.activeName == "one") {
              arrs = this.tabelHeadeTitle;
            } else if (this.activeName == "two") {
              arrs = this.tabelHeadeTitle2;
            } else if (this.activeName == "three") {
              arrs = this.tabelHeadeTitle3;
            }
          }

          let totalArr = [];
          //提取需要合计的字段
          for (var i = 0; i < arrs.length; i++) {
            if (arrs[i].isTotal) {
              totalArr.push(arrs[i].field);
            }
          }
          this.totalArr = totalArr;

          if (this.activeName == "one") {
            this.$nextTick(() => {
              this.$refs.mytable.doLayout();
              this.myTableHeard = arrs;
            });
          } else if (this.activeName == "two") {
            this.$nextTick(() => {
              this.$refs.mytable2.doLayout();
              this.myTableHeard2 = arrs;
            });
          } else if (this.activeName == "three") {
            this.$nextTick(() => {
              this.$refs.mytable3.doLayout();
              this.myTableHeard3 = arrs;
            });
          }
        });
    },

    /****
     *  ===================排序表头彈窗的组件方法 end ===================
     *
     */
  },
};
</script>
<style scoped lang='less'>
.queryItemsAddress {
  display: flex;
  align-items: center;
  width: 700px;
  border: 1px solid #ccc;
  margin-right: 10px;
  height: 30px;
  line-height: 30px;
  border-radius: 4px;
  padding: 0 0 0 4px;

  /deep/ .el-form-item__content {
    display: flex;
    flex: 1;
    min-width: 100px;
  }
  /deep/ .el-select {
    // flex: 1;
    min-width: 60px;
  }
  /deep/ .el-input {
    flex: 1;
    min-width: 100px;
  }
  /deep/ .el-input__inner {
    border-top: none;
    border-bottom: none;
    padding: 0 5px;
  }
}

.chaXunBtns {
  height: 30px;
  line-height: 30px;
  padding: 0 20px;
}

.tb {
  display: flex;
  width: 100%;
  justify-content: space-between;
  // align-items: center;

  .tbLeft {
    flex: 1;
    margin-right: 30px;
    overflow-x: auto;
  }

  .tbRight {
    width: 340px;
    min-height: 300px;
    background-color: #f3f3f3;
    padding: 10px;

    /deep/ .el-form-item {
      margin-bottom: 12px;
    }

    .rbtns {
      width: 100%;
      text-align: center;
      .creatPlanBtns {
        margin: 30px auto;
      }
    }
  }
}

.contents {
  position: relative;

  .queryBtns {
    position: absolute;
    top: 0;
    right: 30px;
    z-index: 999;

    .tableSeting {
      position: absolute;
      right: 0;
      top: 60px;
      // color: ;
    }
  }

  /deep/ .el-form-item__content {
    line-height: 28px;
  }
  /deep/ .el-input__icon {
    line-height: 28px;
  }
}
.glo_form .queryItems {
  width: 225px;
}
</style>